import React, { createContext, useState } from 'react';
import { _cs } from '@togglecorp/fujs';
import TableRow from './TableRow/index.js';
import TableData from './TableData/index.js';

const initialValue = {
  expandedRowKey: undefined,
  setExpandedRowKey: value => {
    console.warn('Trying to set to ', value);
  }
};
const RowExpansionContext = /*#__PURE__*/createContext(initialValue); // FIXME: may need to change return type to JSX.Element and use as jsx to use memoized component

function useRowExpansion(expansionRowChildren) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let expandOnRowClick = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const [expandedRowKey, setExpandedRowKey] = useState();
  const {
    expandedRowClassName,
    expandedCellClassName,
    expansionCellClassName,
    expansionRowClassName
  } = options;
  const rowModifier = React.useCallback(rowOptions => {
    const {
      rowKey,
      row,
      columns
    } = rowOptions;
    const isActive = rowKey === expandedRowKey;
    const newRowProps = {
      className: _cs(row.props.className, isActive && expandedRowClassName),
      children: row.props.children.map(cell => /*#__PURE__*/React.cloneElement(cell, {
        className: _cs(cell.props.className, isActive && expandedCellClassName)
      }))
    };
    let newRow;

    if (expandOnRowClick) {
      newRow = /*#__PURE__*/React.cloneElement(row, { ...newRowProps,
        key: rowKey,
        onClick: () => {
          setExpandedRowKey(oldValue => oldValue === rowKey ? undefined : rowKey);
        }
      });
    } else {
      newRow = /*#__PURE__*/React.cloneElement(row, newRowProps);
    }

    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: `${rowKey}-fragment`
    }, newRow, isActive && /*#__PURE__*/React.createElement(TableRow, {
      key: `${rowKey}-expanded`,
      className: expansionRowClassName
    }, /*#__PURE__*/React.createElement(TableData, {
      colSpan: columns.length,
      className: expansionCellClassName
    }, expansionRowChildren(rowOptions))));
  }, [expandedRowKey, setExpandedRowKey, expansionRowChildren, expandedRowClassName, expandedCellClassName, expansionRowClassName, expansionCellClassName, expandOnRowClick]);
  return [rowModifier, expandedRowKey, setExpandedRowKey];
}

export { RowExpansionContext, useRowExpansion as default };
//# sourceMappingURL=useRowExpansion.js.map
